// Module
var code = "<svg viewBox=\"0 0 28 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M28 18H0V0H28L22.1218 9L28 18Z\" fill=\"black\"/> </svg> ";
// Exports
module.exports = code;